export enum MaskedValueType {
  PASSWORD = 'password',
}
